<template>
<div class="featureitem">
    <router-link :to="{path:'/booklist',query:{listId:books.listId}}">
        <div class="itemcard">
            <img class="faceimg" :src="books.faceImg | objs" />
            <p class="listname">{{books.name}}</p>
            <p class="f18" v-for="item in books.bookList" :key="item.bookId">
                <nobr>{{item.bookName}}</nobr>
            </p> 
           <p>
				<!-- <span class="ludubi">{{books.buyPrice || '0.00'}}</span> -->
				<span class="f14">{{books.sumCount}}期 > </span></p>
        </div>
    </router-link>
</div>
</template>

<style scoped>
a{text-decoration: none;}
p{padding: 0px 20px;}
.featureitem {
    width: 350px;
    float: left;
    margin-bottom: 30px;
}

.itemcard {
    width: 324px;
    padding-bottom: 20px;
    box-shadow: 0px 0px 20px 2px rgba(173, 195, 190, 0.29);
    border-radius: 2px; 
}

.faceimg {
    width: 100%;
}
.listname{margin-top:-42px ;
color: #ffffff;
font-size: 22px;
font-family: Source Han Serif CN;
font-weight: 500;
height: 42px;
line-height: 42px;
overflow: hidden;
background: #242A26;
opacity: 0.9;
}
.f18{ 
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #242A27;

}
.f14{ 
font-size: 14px;
font-family: PingFang SC;
font-weight: bold;
color: #869494;
float: right;
}
.ludubi {
    padding-right: 65px;
    margin-right: 15px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
    height: 22px;
    background-image: url(https://objs.auto-learning.com/xcximages/bi3x.png);
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 65px 18px;
    display: inline-block;
}
</style>

<script>
export default {
    name: "FeatureBook",
    props: [
        "books"
    ]
}
</script>
